import dashboardAdminAPIsService from "../dashboardAdminAPIs";
import { createDataHook } from "../../helpers/util";
import { GOOGLE_CHARTS_TYPES } from "../../consts/graphs";

const useFetchAdminDashboardData = createDataHook(
  dashboardAdminAPIsService,
  (filters, params, controller, apiService = dashboardAdminAPIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    fetchUsersComplianceTrendData: () =>
      apiService.fetchUsersComplianceTrendData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.AREACHART },
        controller.signal
      ),
    fetchComplianceBySiteData: () =>
      apiService.fetchComplianceBySiteData(params, controller.signal),
    fetchUsersCompliancePercentageData: () =>
      apiService.fetchUsersCompliancePercentageData(params, controller.signal),
    fetchCourseCompletionByMonthData: () =>
      apiService.fetchCourseCompletionByMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART },
        controller.signal
      ),
    fetchEstimatedHoursSpentOnElearningData: () =>
      apiService.fetchEstimatedHoursSpentOnElearningData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART },
        controller.signal
      ),
    fetchMostLeastCompliantCoursesData: () =>
      apiService.fetchMostLeastCompliantCoursesData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BARCHART },
        controller.signal
      ),
    fetchActiveUsersNeverLoggedInData: () =>
      apiService.fetchActiveUsersNeverLoggedInData(params, controller.signal),
    fetchLoginsByDayData: () =>
      apiService.fetchLoginsByDayData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BAR },
        controller.signal
      ),
    fetchLoginsByMonthData: () =>
      apiService.fetchLoginsByMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BAR },
        controller.signal
      ),
    fetchLoginsByTimeData: () =>
      apiService.fetchLoginsByTimeData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.AREACHART },
        controller.signal
      ),
  }),
  { preflight: "admin" }
);

export default useFetchAdminDashboardData;
